import { jsx as _jsx } from "react/jsx-runtime";
const SquidWidget = _ref => {
  let {
    fromChainId,
    toChainId,
    fromTokenAddress,
    toTokenAddress
  } = _ref;
  // Construct the config objectq
  const config = {
    integratorId: "gitcoin-50ed7b9e-5407-48c2-9b94-f443b53f6cd4",
    instantExec: true,
    apiUrl: "https://apiplus.squidrouter.com",
    initialAssets: {
      from: {
        chainId: fromChainId,
        address: fromTokenAddress === null || fromTokenAddress === void 0 ? void 0 : fromTokenAddress.toLowerCase()
      },
      to: {
        chainId: toChainId,
        address: toTokenAddress === null || toTokenAddress === void 0 ? void 0 : toTokenAddress.toLowerCase()
      }
    },
    disabledChains: {
      source: ["pacific-1", "osmosis-1"],
      destination: ["pacific-1", "osmosis-1"]
    }
  };

  // Convert config object to a URI-encoded JSON string
  const configString = encodeURIComponent(JSON.stringify(config));

  // Construct the iframe URL
  const iframeUrl = `https://studio.squidrouter.com/iframe?config=${configString}`;
  return /*#__PURE__*/_jsx("div", {
    style: {
      position: "relative",
      width: "500",
      height: "684px"
    },
    children: /*#__PURE__*/_jsx("iframe", {
      title: "squid_widget",
      width: "500",
      height: "684",
      src: iframeUrl,
      style: {
        display: "block"
      }
    })
  });
};
export default SquidWidget;